import { render, staticRenderFns } from "./TaskHistoryLog.vue?vue&type=template&id=52b7a0f6&"
import script from "./TaskHistoryLog.vue?vue&type=script&lang=js&"
export * from "./TaskHistoryLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports